import React from 'react';
import { default as PlatformInlineEdit } from '@atlaskit/inline-edit';

// Public API - aligns with ADS version

// Internal API that aligns with the UI Kit wrapper in `@forge/react`
// This is required since we can't pass functions outside of the runtime
// The workaround is to invoke within the runtime and pass out the result back to the product

var noop = function noop() {};

/**
 * An inline edit displays a custom input component that switches between reading and editing on the same page.
 */
export var InlineEdit = function InlineEdit(props) {
  var _ref = props.forgeDoc.props,
    label = _ref.label,
    _ref$startWithEditVie = _ref.startWithEditViewOpen,
    startWithEditViewOpen = _ref$startWithEditVie === void 0 ? false : _ref$startWithEditVie,
    _ref$keepEditViewOpen = _ref.keepEditViewOpenOnBlur,
    keepEditViewOpenOnBlur = _ref$keepEditViewOpen === void 0 ? false : _ref$keepEditViewOpen,
    _ref$hideActionButton = _ref.hideActionButtons,
    hideActionButtons = _ref$hideActionButton === void 0 ? false : _ref$hideActionButton,
    _ref$isRequired = _ref.isRequired,
    isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
    _ref$readViewFitConta = _ref.readViewFitContainerWidth,
    readViewFitContainerWidth = _ref$readViewFitConta === void 0 ? false : _ref$readViewFitConta,
    _ref$editButtonLabel = _ref.editButtonLabel,
    editButtonLabel = _ref$editButtonLabel === void 0 ? 'Edit' : _ref$editButtonLabel,
    _ref$confirmButtonLab = _ref.confirmButtonLabel,
    confirmButtonLabel = _ref$confirmButtonLab === void 0 ? 'Confirm' : _ref$confirmButtonLab,
    _ref$cancelButtonLabe = _ref.cancelButtonLabel,
    cancelButtonLabel = _ref$cancelButtonLabe === void 0 ? 'Cancel' : _ref$cancelButtonLabe,
    defaultValue = _ref.defaultValue,
    isEditing = _ref.isEditing,
    _ref$onConfirm = _ref.onConfirm,
    providedOnConfirm = _ref$onConfirm === void 0 ? noop : _ref$onConfirm,
    _ref$onCancel = _ref.onCancel,
    providedOnCancel = _ref$onCancel === void 0 ? noop : _ref$onCancel,
    _ref$onEdit = _ref.onEdit,
    providedOnEdit = _ref$onEdit === void 0 ? noop : _ref$onEdit;
  var readViewForgeDoc = props.forgeDoc.children.find(function (child) {
    var _child$props;
    if (child.type === 'ContentWrapper' && ((_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.name) === 'readView') {
      return child;
    }
  });
  var editViewForgeDoc = props.forgeDoc.children.find(function (child) {
    var _child$props2;
    if (child.type === 'ContentWrapper' && ((_child$props2 = child.props) === null || _child$props2 === void 0 ? void 0 : _child$props2.name) === 'editView') {
      return child;
    }
  });
  return /*#__PURE__*/React.createElement(PlatformInlineEdit, {
    label: label,
    startWithEditViewOpen: startWithEditViewOpen,
    keepEditViewOpenOnBlur: keepEditViewOpenOnBlur,
    hideActionButtons: hideActionButtons,
    isRequired: isRequired,
    readViewFitContainerWidth: readViewFitContainerWidth,
    editButtonLabel: editButtonLabel,
    confirmButtonLabel: confirmButtonLabel,
    cancelButtonLabel: cancelButtonLabel,
    defaultValue: defaultValue,
    isEditing: isEditing,
    readView: function readView() {
      return readViewForgeDoc === null || readViewForgeDoc === void 0 ? void 0 : readViewForgeDoc.children.map(props.render);
    },
    editView: function editView() {
      return editViewForgeDoc === null || editViewForgeDoc === void 0 ? void 0 : editViewForgeDoc.children.map(props.render);
    },
    onConfirm: providedOnConfirm,
    onCancel: providedOnCancel,
    onEdit: providedOnEdit
  });
};